import React from "react";

export default function IconDownloadBox(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.95392e-07 1.33333C9.1142e-07 0.966666 0.130556 0.652777 0.391667 0.391666C0.652779 0.130555 0.966667 -4.82282e-07 1.33333 -4.66255e-07L4 -3.49691e-07L4 1.33333L1.33333 1.33333L1.33333 10.6667L10.6667 10.6667L10.6667 1.33333L8 1.33333L8 -1.74846e-07L10.6667 -5.82818e-08C11.0333 -4.22543e-08 11.3472 0.130556 11.6083 0.391667C11.8694 0.652778 12 0.966667 12 1.33333L12 10.6667C12 11.0333 11.8694 11.3472 11.6083 11.6083C11.3472 11.8694 11.0333 12 10.6667 12L1.33333 12C0.966667 12 0.652778 11.8694 0.391667 11.6083C0.130556 11.3472 4.71392e-07 11.0333 4.8742e-07 10.6667L8.95392e-07 1.33333ZM2.66667 5L3.63333 4.06667L5.33333 5.76667L5.33333 -2.91409e-07L6.66667 -2.33127e-07L6.66667 5.76667L8.36667 4.06667L9.33333 5L6 8.33333L2.66667 5Z"
        fill="currentColor"
      />
    </svg>
  );
}
